/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A type of deletion workflow
 * @export
 */
export const AccountDeletionWorkflowType = {
    FreelancerAccount: 'FREELANCER_ACCOUNT',
    MemberOfInactiveClientCompany: 'MEMBER_OF_INACTIVE_CLIENT_COMPANY',
    UndefinedAccount: 'UNDEFINED_ACCOUNT'
} as const;
export type AccountDeletionWorkflowType = typeof AccountDeletionWorkflowType[keyof typeof AccountDeletionWorkflowType];


export function instanceOfAccountDeletionWorkflowType(value: any): boolean {
    for (const key in AccountDeletionWorkflowType) {
        if (Object.prototype.hasOwnProperty.call(AccountDeletionWorkflowType, key)) {
            // @ts-ignore
            if (AccountDeletionWorkflowType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountDeletionWorkflowTypeFromJSON(json: any): AccountDeletionWorkflowType {
    return AccountDeletionWorkflowTypeFromJSONTyped(json, false);
}

export function AccountDeletionWorkflowTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionWorkflowType {
    return json as AccountDeletionWorkflowType;
}

export function AccountDeletionWorkflowTypeToJSON(value?: AccountDeletionWorkflowType | null): any {
    return value as any;
}

